module.exports = __webpack_public_path__ + "assets/images/pages/eu-funds/CabeceiraPrincipia-gal.png?517e7d81";